// extracted by mini-css-extract-plugin
export default {"buttonLink":"ButtonLink_buttonLink__2BuxA","icon":"ButtonLink_icon__9OBiN","title":"ButtonLink_title__8W7Uy","underlined":"ButtonLink_underlined__3PBRC"};